import {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {IconTool} from '@gisatcz/ptr-atoms';
import './style.scss';

const ExpandableSection = ({
	className,
	title,
	Tools,
	minimiseDisallowed,
	children,
}) => {
	const [isMinimised, setIsMinimised] = useState(false);

	const classes = classnames(
		'insar-ExpandableSection',
		{
			'is-expanded': !isMinimised,
			'is-minimised': isMinimised,
		},
		className
	);

	const controlClasses = classnames('insar-ExpandableSection-controlBtn', {
		'is-expand': isMinimised,
		'is-minimise': !isMinimised,
	});

	return (
		<div className={classes}>
			<div className={classnames('insar-ExpandableSection-header')}>
				{typeof title === 'string' ? <h5>{title}</h5> : title}
				{Tools ? Tools : null}
				{title && !minimiseDisallowed ? (
					<IconTool
						className={controlClasses}
						icon={isMinimised ? 'ri-plus' : 'ri-minimise'}
						onClick={() => setIsMinimised(!isMinimised)}
					/>
				) : null}
			</div>
			{!isMinimised && children ? children : null}
		</div>
	);
};

ExpandableSection.propTypes = {
	className: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	Tools: PropTypes.node,
	minimiseDisallowed: PropTypes.bool,
	children: PropTypes.element,
};

export default ExpandableSection;
